export const sameVariant = (a, b) => a.id === b.id && a.colorProd === b.colorProd && a.talleProd === b.talleProd;
export function availableStock(product) {
  const size = product.colores?.find(color => color.color === product.colorProd)
    ?.talles?.find(talle => talle.talle === product.talleProd);
  return Math.max(0, Number(size?.stock) || 0);
}
export function addProduct(items, product) {
  const quantity = Math.max(1, Math.floor(Number(product.cantidad) || 1));
  const existing = items.find(item => sameVariant(item, product));
  const cantidad = Math.min((existing?.cantidad || 0) + quantity, availableStock(product));
  if (cantidad === 0) return items;
  return existing ? items.map(item => sameVariant(item, product) ? { ...item, cantidad } : item)
    : [...items, { ...product, cantidad }];
}
export function changeQuantity(items, variant, delta) {
  return items.map(item => sameVariant(item, variant)
    ? { ...item, cantidad: Math.min(availableStock(item), Math.max(0, item.cantidad + delta)) } : item)
    .filter(item => item.cantidad > 0);
}
export function cartTotals(items) {
  return items.reduce((totals, item) => ({
    totalItems: totals.totalItems + item.cantidad,
    precioTotal: Math.round((totals.precioTotal + Number(item.precioProd) * item.cantidad) * 100) / 100,
  }), { totalItems: 0, precioTotal: 0 });
}
